export default () => {
    const hooks = {};

    const add = type => f =>
        hooks[type] ? hooks[type].push(f) : (hooks[type] = [f]);

    const run = (type, ...args) =>
        hooks[type] ? hooks[type].forEach(f => f(...args)) : undefined;

    return {
        add,
        run,
    };
};
